'use client';

import Image from 'next/image';
import Link from 'next/link';

import '../app/Homepage.css';
import PDFDownload from './PDFdownload';
import productData from './ProductData';

const AllProducts = () => {
  return (
    <div className='service_sec_all'>
      <div className='container px-4'>

        {/* Hero Section */}
        <div className='our_expert_service_all py-5'>
          <div className='service_head'>
            <h1 className='display-5 fw-bold mb-4'>Our Cleanroom Products</h1>
            <p className='lead mb-4'>
              Explore our core cleanroom equipment range with direct links to each product page for specifications,
              applications, and enquiry support.
            </p>
          </div>
          <div className='download_btn d-flex justify-content-center mb-5'>
            <PDFDownload />
          </div>
        </div>

        {/* SEO Intro Content */}
        <div className='row mb-5'>
          <div className='col-12'>
            <div className='p-4 rounded-3' style={{ backgroundColor: '#f0fbfd' }}>
              <h2 className='fw-semibold mb-3' style={{ color: '#00819E' }}>
                High-Performance Cleanroom & Laboratory Equipment
              </h2>
              <p className='mb-3' style={{ color: '#444', lineHeight: '1.8' }}>
                Clean Flow Systems is a trusted manufacturer and supplier of cleanroom and laboratory equipment
                in India. Our products are engineered to meet stringent industry standards including ISO, GMP,
                and WHO guidelines — ensuring contamination-free environments for pharmaceutical, biotech,
                research, and healthcare industries.
              </p>
              <p className='mb-0' style={{ color: '#444', lineHeight: '1.8' }}>
                From laminar airflow units and biosafety cabinets to modular cleanrooms and pass boxes, every
                product is designed for precision, durability, and operational efficiency. Whether you are
                setting up a new lab or upgrading an existing facility, our equipment delivers reliable
                performance under demanding conditions.
              </p>
            </div>
          </div>
        </div>

        {/* Product Grid */}
        <div className='row row-cols-1 row-cols-md-3 row-cols-lg-4 g-4'>
          {productData.products.map((product) => (
            <div key={product.id} className='col'>
              <Link href={`/products/${product.url}`} className='block h-full'>
                <div
                  className='card h-100 shadow-sm !border-none transition-transform duration-300 ease-in-out hover:scale-105'
                  style={{ backgroundColor: '#CCF2FA', borderRadius: '10px', padding: '10px' }}
                >
                  <div className='relative overflow-hidden rounded-[10px]'>
                    <Image
                      src={product.image}
                      alt={product.title}
                      width={480}
                      height={480}
                      className='w-full h-auto object-cover transition-transform duration-300 ease-in-out hover:scale-105'
                    />
                  </div>
                  <div className='card-body text-center'>
                    <h2 className='card-title !text-[#00819E] !font-medium !text-[20px]'>{product.title}</h2>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        {/* Product Category Info Section */}
        <div className='row mt-5 g-4'>
          <div className='col-12'>
            <h2 className='fw-semibold mb-4' style={{ color: '#00819E' }}>
              What We Offer
            </h2>
          </div>

          <div className='col-md-6 col-lg-4'>
            <div className='p-4 h-100 rounded-3' style={{ backgroundColor: '#f0fbfd', border: '1px solid #cceef5' }}>
              <h3 className='fw-semibold mb-2' style={{ color: '#00819E', fontSize: '18px' }}>
                Laminar Airflow & Biosafety Cabinets
              </h3>
              <p style={{ color: '#555', lineHeight: '1.7', fontSize: '15px' }}>
                Our laminar airflow workstations and biosafety cabinets provide a sterile, particle-free work
                environment. Ideal for microbiology labs, pharmaceutical manufacturing, and research facilities
                requiring ISO Class 5 or better air quality.
              </p>
            </div>
          </div>

          <div className='col-md-6 col-lg-4'>
            <div className='p-4 h-100 rounded-3' style={{ backgroundColor: '#f0fbfd', border: '1px solid #cceef5' }}>
              <h3 className='fw-semibold mb-2' style={{ color: '#00819E', fontSize: '18px' }}>
                Air Showers & Pass Boxes
              </h3>
              <p style={{ color: '#555', lineHeight: '1.7', fontSize: '15px' }}>
                Air showers and pass boxes are essential entry and transfer systems in cleanroom facilities.
                They remove surface contaminants from personnel and materials before entering controlled
                environments, maintaining cleanroom integrity.
              </p>
            </div>
          </div>

          <div className='col-md-6 col-lg-4'>
            <div className='p-4 h-100 rounded-3' style={{ backgroundColor: '#f0fbfd', border: '1px solid #cceef5' }}>
              <h3 className='fw-semibold mb-2' style={{ color: '#00819E', fontSize: '18px' }}>
                Modular Cleanrooms & Soft Wall Cleanrooms
              </h3>
              <p style={{ color: '#555', lineHeight: '1.7', fontSize: '15px' }}>
                We design and install both modular hardwall and soft wall cleanrooms tailored to your space
                and classification requirements. Suitable for electronics, pharma, food processing, and
                medical device manufacturing environments.
              </p>
            </div>
          </div>

          <div className='col-md-6 col-lg-4'>
            <div className='p-4 h-100 rounded-3' style={{ backgroundColor: '#f0fbfd', border: '1px solid #cceef5' }}>
              <h3 className='fw-semibold mb-2' style={{ color: '#00819E', fontSize: '18px' }}>
                Laboratory Modular Furniture
              </h3>
              <p style={{ color: '#555', lineHeight: '1.7', fontSize: '15px' }}>
                Our laboratory modular furniture is built for durability and flexibility. Designed with
                chemical-resistant surfaces and ergonomic layouts, it supports efficient workflows in
                research, testing, and quality control labs.
              </p>
            </div>
          </div>

          <div className='col-md-6 col-lg-4'>
            <div className='p-4 h-100 rounded-3' style={{ backgroundColor: '#f0fbfd', border: '1px solid #cceef5' }}>
              <h3 className='fw-semibold mb-2' style={{ color: '#00819E', fontSize: '18px' }}>
                Fume Exhaust Hood & Powder Sampling Booth
              </h3>
              <p style={{ color: '#555', lineHeight: '1.7', fontSize: '15px' }}>
                Fume exhaust hoods and powder sampling booths protect operators from hazardous chemicals,
                vapors, and fine particles. Essential for chemical labs, pharmaceutical weighing areas, and
                any environment handling volatile or toxic substances.
              </p>
            </div>
          </div>

          <div className='col-md-6 col-lg-4'>
            <div className='p-4 h-100 rounded-3' style={{ backgroundColor: '#f0fbfd', border: '1px solid #cceef5' }}>
              <h3 className='fw-semibold mb-2' style={{ color: '#00819E', fontSize: '18px' }}>
                Anti Vibration Tables & Pressure Modules
              </h3>
              <p style={{ color: '#555', lineHeight: '1.7', fontSize: '15px' }}>
                Anti vibration tables eliminate mechanical disturbances for sensitive instruments like
                balances and microscopes. Pressure modules maintain differential pressure levels critical
                for maintaining cleanroom classification standards.
              </p>
            </div>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className='row my-5'>
          <div className='col-12'>
            <div className='p-4 rounded-3' style={{ backgroundColor: '#00819E' }}>
              <h2 className='fw-semibold mb-4 text-white'>Why Choose Clean Flow Systems?</h2>
              <div className='row g-3'>
                {[
                  { title: 'ISO & GMP Compliant', desc: 'All products meet international cleanroom and laboratory safety standards.' },
                  { title: 'Custom Fabrication', desc: 'Equipment tailored to your facility dimensions, classification, and workflow needs.' },
                  { title: 'End-to-End Support', desc: 'From consultation and installation to after-sales service and maintenance.' },
                  { title: 'Proven Industry Experience', desc: 'Trusted by pharmaceutical, biotech, research, and healthcare facilities across India.' },
                  { title: 'Quality Materials', desc: 'Built with SS 304/316 stainless steel and high-grade components for long-lasting performance.' },
                  { title: 'Fast Delivery', desc: 'Efficient production and logistics ensure timely delivery to your project site.' },
                ].map((item, index) => (
                  <div className='col-md-6 col-lg-4' key={index}>
                    <div className='d-flex align-items-start gap-2'>
                      <span style={{ color: '#CCF2FA', fontSize: '20px', marginTop: '2px' }}>✓</span>
                      <div>
                        <h3 className='text-white fw-semibold mb-1' style={{ fontSize: '16px' }}>{item.title}</h3>
                        <p className='mb-0' style={{ color: '#CCF2FA', fontSize: '14px', lineHeight: '1.6' }}>{item.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className='row mb-5'>
          <div className='col-12 text-center'>
            <h2 className='fw-semibold mb-3' style={{ color: '#00819E' }}>
              Looking for a Specific Cleanroom Solution?
            </h2>
            <p className='mb-4' style={{ color: '#555', maxWidth: '600px', margin: '0 auto 20px' }}>
              Our team of experts is ready to help you find the right equipment for your requirements.
              Get in touch for a free consultation or a custom quote today.
            </p>
            <Link
              href='/contact-us'
              className='btn px-4 py-2 fw-semibold text-white'
              style={{ backgroundColor: '#00819E', borderRadius: '8px', textDecoration: 'none' }}
            >
              Contact Us
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AllProducts;
